module.exports = __webpack_public_path__ + "media/images/athletes/3401-d5e953443940df31c7ef971bf9317be5.png";